<template>

<div class="main list-view no-sub-header">

	<div class="filters">

		<div v-if="showDetail">
			<button class="button action" @click="saveItem()">Save Register</button>
			<button class="button neutral" @click="backToList()">Back To List</button>
		</div>
		<div v-else>
			<ul class="checkbox-group">
				<li>
					<span :class="['pointer', 'far', filters.include_inactive ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('include_inactive')"></span>
					<label>Include Inactive</label>
				</li>
			</ul>
			<div class="divider"></div>
			<button class="button neutral" @click="getItem({})">Add Register</button>
			<div class="divider"></div>
			<div :class="['extra-menu-item', loading ? 'disabled' : '']" @click="doExport()">Export CSV</div>
		</div>
	</div>

	<div v-if="showDetail" class="detail" style="max-width: 20em;">
        <label>Code</label>
		<input type="text" v-model="listDetail.device_license_number" />
        <label>Nickname</label>
		<input type="text" v-model="listDetail.device_nickname" />
        <label>Created</label>
		<input type="date" readonly :value="listDetail.date_created" />
        <label>Last Used</label>
		<input type="date" readonly :value="listDetail.last_used" />
		<div class="v-spaced">
			<checkbox v-model="listDetail.internal_use_only" label="In Use" :key="'internal_use_only' + listDetail.internal_use_only" />
		</div>
		<div class="v-spaced">
			<checkbox v-model="listDetail.inactive" label="Inactive" :key="'inactive' + listDetail.inactive" />
		</div>
	</div>

	<div v-else class="list report-list">

	    <div v-if="list.length == 0" class="empty-list">
	        This list is empty
	    </div>

		<div v-else>
			<div class="detail-sub-header right">
				<pagination v-if="showPagination" :paging="paging" @updatePage="goToPage"></pagination>
			</div>

			<table class="data-list" cellpadding="0" cellspacing="0">
				<thead>
					<tr>
						<th class="list left">Code</th>
						<th class="list left">Nickname</th>
						<th class="list left">Created</th>
						<th class="list left">Last Used</th>
						<th class="list center">In Use</th>
						<th class="list center">Inactive</th>
					</tr>
				</thead>
				<tr v-for="item in list" class="clickable-list-item" @click="getItem(item)">
					<td class="list left">{{ item.device_license_number }}</td>
					<td class="list left">{{ item.device_nickname }}</td>
					<td class="list left">{{ item.date_created }}</td>
					<td class="list left">{{ item.last_used }}</td>
					<td class="list center"><i v-if="item.internal_use_only" class="fa fa-check"></i></td>
					<td class="list center"><i v-if="item.inactive" class="fa fa-check"></i></td>
				</tr>
			</table>
		</div>
	</div>

	<message-modal v-if="message" :message="message" :loading="loading" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

	<iframe id="download" src="" style="display: none;"></iframe>

</div>

</template>

<script>
import Checkbox from '@/components/Checkbox.vue'
export default {
	name: 'register-codes',
    components: {
		'checkbox': Checkbox
    },
	data() {
		return {
            loading: false,
			saving: false,
            message: '',
            messageStatus: '',
            messageTimeout: 0,
            list: [],
			paging: {},
			showPagination: true,
            filters: {},
            showDetail: false,
			listDetail: {},
			gettingExport: false,
		}
	},
	created() {
		this.clearFilters(true)
	},
	methods: {
		clearFilters(getList) {
			this.filters = {
				include_inactive: false,
				do_export: false
			}
			if (getList) {
				this.getList(1)
			}
		},
		toggleFilter(which) {
			this.filters[which] = !this.filters[which]
			this.getList()
		},
		getList() {
            if (this.loading) { return }
			this.loading = true
			if (this.filters.do_export) {
				this.message = 'Generating CSV for ' + this.list.length + ' items...'
			} else {
				this.message = 'Getting list...'
			}
			this.apiCall({ destination: 'get_list_device_licenses', data: this.filters }).then(obj => {
				this.loading = false
				this.messageStatus = obj.status
				if (obj.status == 'success') {
					if (this.filters.do_export) {
						this.filters.do_export = 0
						// accommodate live server filecache latency
						setTimeout(() => {
							this.message = 'Downloading CSV...'
							document.getElementById("download").src = obj.download_url
							this.messageTimeout = 2000
						}, 500)
					} else {
						this.message = ''
						this.list = obj.list
					}
				}
			}).catch(err => {
				console.log(err)
			})
		},
		doExport() {
			this.filters.do_export = true
			this.getList()
		},
		getItem(item) {
			this.listDetail = item
			this.showDetail = true
		},
		saveItem() {
			if (this.saving) { return }
			this.messageStatus = ''
			if (this.listDetail.device_license_number == '' || isNaN(this.listDetail.device_license_number)) {
				this.message = 'Please enter a code (numbers only).'
				this.messageStatus = 'invalid'
				return
			}
			if (this.listDetail.device_nickname == '') {
				this.message = 'Please enter a register nickname.'
				this.messageStatus = 'invalid'
				return
			}
			this.saving = true
			this.message = 'Saving register...'
			this.apiCall({ destination: 'save_item_device_license', data: this.listDetail }).then(obj => {
				this.saving = false
				this.messageStatus = obj.status
				if (obj.status == 'success') {
					this.message = 'Register saved!'
					this.messageTimeout = 1500
				}
			}).catch(err => {
				console.log(err)
			})

		},
		backToList() {
			this.showDetail = false
			this.listDetail = {}
		}
	}
}
</script>
